import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import fetchTeleraidologyList from '@custom/rtk-apis/teleraidologycustomer/teleraidologyCustomerList';

// Define the TeleraidologyState interface with additional fields like 'status' and 'message'
export interface TeleraidologyState {
    data: any[];  // Adjust type as needed
    status: string;
    loading: boolean;
    error: string | null;
    totalRecords: number;
    message: string | null;
}

const initialState: TeleraidologyState = {
    data: [],
    status: "",
    loading: false,
    error: null,
    totalRecords: 0,
    message: null,
};

const teleraidologyCustomerSlice = createSlice({
    name: 'teleraidology',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Handle the different states of the async thunk
        builder
            .addCase(fetchTeleraidologyList.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.status = 'pending';
            })
            .addCase(fetchTeleraidologyList.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.status = action.payload.status || 'success'; // Set status from the response
                state.data = action.payload.result.list || [];  // Assuming data is in the `data` field
                state.totalRecords = action.payload?.result.totalContent || 0; // Assuming total records count
                state.message = action.payload.msg || null; // Set message if available
            })
            .addCase(fetchTeleraidologyList.rejected, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.status = 'rejected';
                state.error = action.payload || 'Failed to fetch teleraidology customer list';
                state.message = action.payload?.msg || null; // Set error message if available
            });
    },
});

export default teleraidologyCustomerSlice.reducer;
